/**
 * Body of POST /domain-actions/cases/new_amortization/{resource_id} and of the cost-preview
 * POST /customer--amortization/details-new-amortization (both untyped in swagger — "Swagger
 * lies", the actions require this plan shape).
 */
export interface AmortizationCommitBody {
  /** UTC midnight of the first payment day (RFC 1123 string — the API's date format). */
  amortization_date: string
  number_of_advices: number
  cases: { id: string }[]
  debt_collections: { id: string }[]
  enforcements: { id: string }[]
  send_first_advice_letter_only: boolean
  skip_amortization_setup_fee: boolean
}

/**
 * Outcome of the commit POST. `sent_to_creditor`: the capital falls in a ladder step the
 * creditor must approve, so the API opened a creditor decision instead of creating the plan.
 */
export type AmortizationFeedback = 'success' | 'failed' | 'sent_to_creditor'

/** Multi-mode wizard pages, in order. `feedback` is the terminal screen and is not counted. */
export const WIZARD_PAGES = ['select', 'setup'] as const
export type WizardPage = (typeof WIZARD_PAGES)[number]
export type AmortizationPage = WizardPage | 'feedback'
